/**
 * WIDGET_COMPATIBLE_COMPS — maps each widget type to the list of
 * component types that are valid as field/dimension options.
 *
 * Single place to tweak per-widget field compatibility.
 * Consumed by each widget's config form when building field options.
 */
export const WIDGET_COMPATIBLE_COMPS = {
  WidgetMetricCard: [
    'NumberInput',
    'CheckboxList',
    'RadioList',
    'DropdownSingle',
    'DropdownMulti',
    'TagsInputSingle',
    'TagsInputMulti'
  ],
  // WidgetBarChart: [ ... ],
  // WidgetPieChart: [ ... ],
  // WidgetLineChart: [ ... ],
};
